import { Col, Flex, Row } from "antd";
import BadgeComponent from "./components/Badge";
import Dashboard from "./components/Dashboard";
import GraficoPizza from "./components/GraficoPizza";
import { Container, ContainerTitulo, TextTitle } from "./styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import AssinaturasAtivas from "./components/AssinaturasAtivas";
import AnunciosAtivos from "./components/AnunciosAtivos";
import GraficoPizzaCotas from "./components/GraficoPizzaCotas";

export default function ViewDashboard() {
  return (
    <Container>
      <Row align="middle" style={{ marginBottom: 20 }}>
        <Col span={1}>
          <Flex align="center" justify="center" style={{ marginTop: 15 }}>
            <a href={`/inicio`}>
             
            </a>
          </Flex>
        </Col>
        <Col span={23}>
          <ContainerTitulo>
            <TextTitle>DashBoard</TextTitle>
          </ContainerTitulo>
        </Col>
      </Row>

      {/* Badges ocupando toda largura */}
      <Row style={{ marginBottom: 20, alignContent: "center" }}>
        <Col span={6}>
          <BadgeComponent />
        </Col>
        <Col span={6}>
          <Col span={12}>{/* <AssinaturasAtivas /> */}</Col>
        </Col>
        <Col span={6}>
          <AnunciosAtivos />
        </Col>
        <Col span={6}>
          <BadgeComponent />
        </Col>
      </Row>

      {/* Primeira linha com dois gráficos lado a lado */}
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col span={12}>
          <Dashboard />
        </Col>
        <Col span={12}>
          <GraficoPizza />
        </Col>
      </Row>

      {/* Segunda linha com gráfico ocupando duas colunas */}
      <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
        <Col span={12}>
          <GraficoPizzaCotas />
        </Col>
        <Col span={12}></Col>
      </Row>
    </Container>
  );
}
